class GDLModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

class GDLModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        const productMediaModal = document.querySelector(
          ".product-media-modal"
        );
        const productMediaModalContent = document.querySelector(
          ".product-media-modal__content"
        );

        if (
          (event.pointerType === "mouse" &&
            !event.target.closest("deferred-media, product-model") &&
            !event.target.classList.contains("pdp-zoom-in--to-top")) ||
          !event.target.parentNode.classList.contains("pdp-zoom-in--to-top")
        )
          this.hide();

        // event click check for zoom in back to top
        if (
          event.target.classList.contains("pdp-zoom-in--to-top") ||
          event.target.parentNode.classList.contains("pdp-zoom-in--to-top")
        ) {
          productMediaModal.setAttribute("open", "");
          productMediaModalContent.scrollTop = 0;
          productMediaModalContent.style.transition = "0.2s ease-in-out";
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    document.querySelector('.btq-excl-find-in-store.step-1').classList.remove("hidden");
    document.querySelector('.btq-excl-find-in-store.step-2').classList.add("hidden");
    document.querySelector('.btq-excl-find-in-store.step-3').classList.add("hidden");
    document.querySelector('.selected-btq .btq-info-ctn')?.remove();
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("gdl-modal-dialog", GDLModalDialog);
customElements.define("gdl-modal-opener", GDLModalOpener);
